import { queryOptions } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { Catalogue, PermissionGroup } from "@/types/catalogue"

/** The FCA's regulated activities. Fixed per handbook edition, so never stale. */
export const permissionQueries = {
  groups: () =>
    queryOptions({
      queryKey: apiKey("/permissions"),
      queryFn: async ({ signal }) =>
        await apiFetch<Catalogue<PermissionGroup>>("/permissions", {
          anonymous: true,
          signal,
        }),
      staleTime: Number.POSITIVE_INFINITY,
    }),
}
